import React from "react";
// import {useTranslation} from 'react-i18next';
// import cn from 'classnames';
import { NavLink, useLocation } from "react-router-dom";
import {
  LinksContainer,
  LinkText,
  NavBarContainer,
  StyledNavLink,
  TitleContainer,
} from "./styled";
import { LinkItem, NavBarProps } from "./types";
// import {LocationStates} from '../../../views/VerifyModalScreen/VerifyModalScreen';
// import {GlobalLocationTypes} from '../../../utils/types';
// import {useComputedReservationDetails} from 'context/computedReservationDetails';
// import {PATHS} from '../../../Routes';
// import MobileNavigation from '../MobileNavigation';
// import styles from './NavBar.module.sass';
const defaultProps: NavBarProps = {
  title: "",
};

function NavBar({ title }: NavBarProps) {
  const links = React.useMemo<LinkItem[]>(() => {
    const links = [];
    links.push({
      route: "/",
      label: "Confirm",
    });

    links.push({
      route: "/verify",
      label: "Verify",
    });

    links.push({
      route: "/sign",
      label: "Sign",
    });
    return links;
  }, []);
  return (
    <>
      <NavBarContainer>
        <TitleContainer>{title}</TitleContainer>
        <LinksContainer>
          {links.map(({ route, label, disabled }, i) => {
            return (
              <StyledNavLink
                key={i}
                to={{
                  pathname: route,
                }}
                activeClassName="active-nav-link"
                exact={route != '/' ? true : false}
              >
                <LinkText>{label}</LinkText>
              </StyledNavLink>
            );
          })}
        </LinksContainer>
      </NavBarContainer>
      {/* <div className={styles.wrapperNavigation}>
        <div className={cn(className, styles.container)}>
          <div className={styles.title}>{title}</div>
          <div className={styles.links}>
            {links.map(({route, label, disabled}, i) => {
              if (disabled) {
                return (
                  <div
                    key={i}
                    className={cn('crumbsWrapper', styles.wrapperLink, styles.disabled)}
                  >
                    <span className={styles.link}>{label}</span>
                  </div>
                );
              }
              return (
                <NavLink
                  key={i}
                  className={cn('crumbsWrapper', styles.wrapperLink)}
                  to={{
                    pathname: route,
                    state: location.state,
                  }}
                  activeClassName={styles.active}
                >
                  <span className={styles.link}>{label}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
      </div>

      <div className={styles.wrapperMobileNavigation}>
        <MobileNavigation title={title} links={links} extraLinks={extraLinks} /> 
      </div>*/}
    </>
  );
}

NavBar.defaultProps = defaultProps;

export { NavBar };
